import { render, staticRenderFns } from "./BudgetOld.vue?vue&type=template&id=4bd70f1c&scoped=true"
import script from "./BudgetOld.vue?vue&type=script&lang=js"
export * from "./BudgetOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd70f1c",
  null
  
)

export default component.exports